import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentUnderline({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <u>{children}</u>;
}
